export class DaysOption {
  Value: number;
  Label: string;

  constructor(value: number, label: string) {
    this.Value = value;
    this.Label = label;
  }
}